import '../../../../utils/index.mjs';
import { datePickerSharedProps, selectionModeWithDefault } from './shared.mjs';
import { buildProps } from '../../../../utils/vue/props/runtime.mjs';

const basicMonthTableProps = buildProps({
  ...datePickerSharedProps,
  selectionMode: selectionModeWithDefault("month")
});

export { basicMonthTableProps };
//# sourceMappingURL=basic-month-table.mjs.map
